import type {BlindLevel} from '../../types/domain'
import React from 'react'
import Blind from '../blind/Blind'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'


function NextLevel({blind, onBreak, length}: {blind?: BlindLevel | null; onBreak?: boolean; length: number; level?: number}) {
  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      { onBreak ?
        <Typography sx={{color: 'text.secondary', lineHeight: 1.5, fontSize: '1rem'}}>
          {length} minute break is next
        </Typography> :
        blind && <Blind blind={blind} isNextLevel={true}/>
      }
    </Grid>
  )
}

export default NextLevel
